import React from 'react';

const Dashboard = React.lazy(() => import('../components/DashboardModule/DashboardModule'));

const routes: any = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    exact: false,
    scopes: [],
  },
];

export default routes;
